const { cELM, getWindowHeight } = require("../utils");
const Scroller = require("../components/scroller");
const Provider = require("../components/blocks/provider.js");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
const Notification = require("../components/notification");
const ScrollNotification = require("../components/scroll-notification");
const Chat = require("../chat");

class QuizModule {
  constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    this.elContainer = cELM("div", "quiz-module");
    this.contentHash = {};
    this.typingIndicator = null;
    this.currentIndex = 0;
    this.answers = [];
  }

  handle() {
    const _elm = this.handleOnMessage();
    this.elContainer.addELM(_elm);

    // add show more button
    this.showMore(_elm.getELM());
    Scroller.scrollToElm(_elm, () => {
      _elm.focus();
    });
  }

  callback(val) {
    const _self = this; 

    this.answers.push(val);
    this.currentIndex++;

    if (this.currentIndex < this.value.values.questions.length) {
      this.handle();
    } else {
      Chat.default.send({
          id: (_self.value || {}).id,
          answers: this.answers
        }, 
        null, 
        this.elContainer
      );
    }
  }

  handleOnMessage() {
    const questions = this.value.values.questions;
    const question = questions[this.currentIndex];

    const valueValues = (this.value || {}).values || {};
    const variable = (this.value || {}).variable || 
                      (this.value || {}).answerKey || 
                      valueValues.variable || 
                      valueValues.answerKey;

    const component = new Block({
      data: {
        format: "phq",
        icon: this.value.icon,
        text:
          "<span class='font-light'>" +
          this.value.values.instruction +
          "</span><br/><span class='heavy-font'>" +
          question.title +
          "</span>",
        subtext: question.subtext,
        buttons: question.buttons,
        variable: variable,
        callback: this.callback.bind(this),
      },
    });

    return component;
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  showMore(elm) {
    const height = getWindowHeight();
    const bound = elm.getBoundingClientRect();

    if (bound.height > height) {
      ScrollNotification.attachElement(elm);
    }
  }
}

module.exports = QuizModule;
